// extracted by mini-css-extract-plugin
export var externalLink = "_d8-0";
export var internalLinkLabel = "_d8-1";